class SKEvent {
  constructor(event) {
    this.event = event;
  }

  listen(callback, target = window) {
    if (typeof target === 'undefined') {
      return;
    }

    target.addEventListener(this.event, callback);
  }

  removeListener(callback, target = window) {
    if (typeof target === 'undefined') {
      return;
    }

    target.removeEventListener(this.event, callback);
  }

  dispatch(target = window) {
    if (typeof target === 'undefined') {
      return;
    }

    target.dispatchEvent(new Event(this.event));
  }
}

export default SKEvent;
